// extracted by mini-css-extract-plugin
export default {"div":"SplideSlick_div__C9vEW"};